import { render, staticRenderFns } from "./basePrice.vue?vue&type=template&id=db4fd862&scoped=true&"
import script from "./basePrice.vue?vue&type=script&lang=js&"
export * from "./basePrice.vue?vue&type=script&lang=js&"
import style0 from "./basePrice.vue?vue&type=style&index=0&id=db4fd862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4fd862",
  null
  
)

export default component.exports